import { ChevronDown, ChevronUp } from "lucide-react";
import useComponentClickOutside from "utils/hooks/use-component-click-outside";

export function InputDropdown({ value, onChange, InputValues, open, setOpen }) {
  const options = InputValues || [];

  const { wrapRef, isComponentVisible, toggleChild } = useComponentClickOutside();

  const isOpen = open && isComponentVisible;

  return (
    <div
      ref={wrapRef}
      className="relative w-full"
      onClick={toggleChild}
    >
      {/* Trigger */}
      <button
        type="button"
        onClick={() => setOpen(prev => !prev)}
        className="
          w-full bg-gray-50 border border-gray-200 rounded py-2 px-3 text-sm text-gray-700 font-medium flex justify-between items-center transition
        "
      >
        <span>{value || "Points"}</span>
        {isOpen ? (
          <ChevronUp size={16} className="text-gray-400" />
        ) : (
          <ChevronDown size={16} className="text-gray-400" />
        )}
      </button>

      {isOpen && (
        <div
          className="
            absolute left-0 mt-1 w-full bg-white 
            border border-gray-200 shadow-lg z-50
          "
        >
          {options.map((opt) => (
            <button
              key={opt}
              type="button"
              onClick={() => {
                onChange(opt);
                setOpen(false);
              }}
              className="w-full text-left px-3 py-2 text-sm cursor-pointer transition hover:bg-primary">
              {opt}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
